import React, { useEffect } from 'react'
import Header from '../Layout/Header'
import { useDispatch, useSelector } from 'react-redux';
import { allapiAction } from '../../Redux/common/action';

function Reserve() {
    //   const deshboard = useSelector((state) =>
    //     state?.allapi?.deshboard ? state?.allapi?.deshboard : {}
    //   );
      const get_profile = useSelector((state) =>
        state?.allapi?.get_profile ? state?.allapi?.get_profile : {}
      );
      const deshboard = useSelector((state) =>
        state?.allapi?.deshboard ? state?.allapi?.deshboard : {}
      );
      const dispatch = useDispatch();
    
      useEffect(() => {
        // dispatch(allapiAction.vendordeshBoradData({}));
        // dispatch(allapiAction.categoryWiseSale({}));
        // dispatch(allapiAction.deshBoradDataUserData());
        dispatch(allapiAction.getprofile());
        dispatch(allapiAction.deshBoradDataUserData());
    
        return () => {};
      }, []);
    
  return (
    <div>
        <Header/>
        <div className='reserve'>
        <div class="container mt-5 pt-5  mb-5 pb-5">
        <div class="row g-3 mb-5">
            <div class="col-12">
                <div class="card p-1 shadow-sm main-1-border1">
                    <h6><small>Today Earnings</small></h6>
                    <h4 class="fw-bold"><small>{get_profile?.todayProfit? get_profile?.todayProfit?.toFixed(4) : 0}</small></h4>
                </div>
            </div>
          
            </div>
            <div class="row g-3">
            <div class="col-6">
                <div class="card p-1 shadow-sm main-1-border4">
                    <h6><small>Total Order</small></h6>
                    <h4 class="fw-bold"><small>{deshboard?.totalOrder}</small></h4>
                </div>
            </div>
            {/* <div class="col-4">
                <div class="card p-1 shadow-sm main-1-border4">
                    <h6><small>Reservation Range</small></h6>
                    <h4 class="reservation-range"><small>50~150</small></h4>
                </div>
            </div> */}
            <div class="col-6">
                <div class="card p-1 shadow-sm main-1-border5">
                    <h6><small>Wallet Balance</small></h6>
                    <h4><small>{get_profile?.balance ? get_profile?.balance : 0}</small></h4>
                </div>
            </div>
            {/* <div class="col-4">
                <div class="card p-1 shadow-sm main-1-border6">
                    <h6><small>Balance for Reservation</small></h6>
                    <h4><small>0</small></h4>
                </div>
            </div> */}
        </div>

        <div class="row g-3 mt-3">
            <div class="col-6">
                <div class="card p-1 shadow-sm main-1-border3">
                    <h6><small>Total Team</small></h6>
                    <h4 class="fw-bold"><small>{deshboard?.allTeam ? deshboard?.allTeam : 0}</small></h4>
                </div>
            </div>
            {/* <div class="col-4">
                <div class="card p-1 shadow-sm main-1-border4">
                    <h6><small>Reservation Range</small></h6>
                    <h4 class="reservation-range"><small>50~150</small></h4>
                </div>
            </div> */}
            <div class="col-6">
                <div class="card p-1 shadow-sm main-1-border5">
                    <h6><small>Direct Team</small></h6>
                    <h4><small>{deshboard?.DirectTeam ? deshboard?.DirectTeam : 0}</small></h4>
                </div>
            </div>
            {/* <div class="col-4">
                <div class="card p-1 shadow-sm main-1-border6">
                    <h6><small>Balance for Reservation</small></h6>
                    <h4><small>0</small></h4>
                </div>
            </div> */}
        </div>
        <div class="row g-3 mt-3">
            <div class="col-6">
                <div class="card p-1 shadow-sm main-1-border4">
                    <h6><small>Level Income</small></h6>
                    <h4 class="fw-bold"><small> {deshboard?.lavelIncomes
                      ? deshboard?.lavelIncomes?.toFixed(2)
                      : 0}</small></h4>
                </div>
            </div>
            {/* <div class="col-4">
                <div class="card p-1 shadow-sm main-1-border4">
                    <h6><small>Reservation Range</small></h6>
                    <h4 class="reservation-range"><small>50~150</small></h4>
                </div>
            </div> */}
       <div class="col-6">
                <div class="card p-1 shadow-sm main-1-border2">
                    <h6><small>Roylity Income</small></h6>
                    <h4 class="fw-bold"><small> {deshboard?.matchingIncomes
                      ? deshboard?.matchingIncomes?.toFixed(2)
                      : 0}</small></h4>
                </div>
            </div>
            {/* <div class="col-4">
                <div class="card p-1 shadow-sm main-1-border6">
                    <h6><small>Balance for Reservation</small></h6>
                    <h4><small>0</small></h4>
                </div>
            </div> */}
        </div>
        {/* <div class="row mt-4 p-3 ">
            <ul class="nav nav-tabs d-flex justify-content-center" id="categoryTabs" role="tablist">
                <li class="nav-item" role="presentation">
                    <button class="nav-link active text-dark" id="women-tab" data-bs-toggle="tab"
                        data-bs-target="#women" type="button" role="tab" aria-controls="women"
                        aria-selected="true">Today's</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link text-dark" id="men-tab" data-bs-toggle="tab" data-bs-target="#men"
                        type="button" role="tab" aria-controls="men" aria-selected="false">Reserve</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link text-dark" id="kids-tab" data-bs-toggle="tab" data-bs-target="#kids"
                        type="button" role="tab" aria-controls="kids" aria-selected="false">Collected</button>
                </li>

            </ul>

            <div class="tab-content m-0 p-0" id="categoryTabsContent">
                <div class="tab-pane fade show active" id="women" role="tabpanel" aria-labelledby="women-tab">
                    <div class="no-data mt-4 text-center">
                        <div class="d-flex justify-content-center">
                            <img class="w-50" src="https://cdn-icons-png.flaticon.com/512/4076/4076432.png"
                                alt="No Data"/>
                        </div>
                        <h5>No Data Available</h5>
                        <p>(GMT+05:30) 2025/03/02 16:37:35</p>
                    </div>
                </div>


                <div class="tab-pane fade" id="men" role="tabpanel" aria-labelledby="men-tab">
                    <div class="">
                        <div class="d-flex gap-1 mt-3">
                            <div class="dropdown">
                                <button class="custom-box dropdown-toggle" type="button" data-bs-toggle="dropdown"
                                    aria-expanded="false">
                                    <span>Lv0</span> <span class="">1.8-1.95%</span>
                                </button>
                                <ul class="dropdown-menu">
                                    <li class="py-2 text-muted">LV &nbsp;&nbsp; Income(%)</li>
                                    <li class="py-2">
                                        <span class="">Lv0</span>
                                        <span class="">1.8-1.95%</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="custom-box">
                                <span><img class="main-1-logo" src="img/t logo.png" alt=""/> 50-150</span>
                            </div>
                            <div class="custom-box info-icon">
                                &#8505;
                            </div>
                        </div>

                        <button
                            class="mt-3 d-flex justify-content-center btn w-100 main-1-btn-bg rounded-3 border">Confirm</button>

                    </div>

                </div>

                <div class="tab-pane fade" id="kids" role="tabpanel" aria-labelledby="kids-tab">
                    <div class="no-data mt-4 text-center">
                        <div class="d-flex justify-content-center">
                            <img class="w-50" src="https://cdn-icons-png.flaticon.com/512/4076/4076432.png"
                                alt="No Data"/>
                        </div>
                        <h5>No Data Available</h5>
                        <p>(GMT+05:30) 2025/03/02 16:37:35</p>
                    </div>
                </div>
            </div>
        </div> */}
           <div class="row g-3 mt-3">
            <div class="col-6">
                <div class="card p-1 shadow-sm main-1-border4">
                    <h6><small>Direct Income</small></h6>
                    <h4 class="fw-bold"><small>  {deshboard?.directincome
                      ? deshboard?.directincome?.toFixed(2)
                      : 0}</small></h4>
                </div>
            </div>
            {/* <div class="col-4">
                <div class="card p-1 shadow-sm main-1-border4">
                    <h6><small>Reservation Range</small></h6>
                    <h4 class="reservation-range"><small>50~150</small></h4>
                </div>
            </div> */}
       <div class="col-6">
                <div class="card p-1 shadow-sm main-1-border2">
                    <h6><small> Profit</small></h6>
                    <h4 class="fw-bold"><small>   {deshboard?.aarohiIncome
                      ? deshboard?.aarohiIncome?.toFixed(2)
                      : 0}</small></h4>
                </div>
            </div>
            {/* <div class="col-4">
                <div class="card p-1 shadow-sm main-1-border6">
                    <h6><small>Balance for Reservation</small></h6>
                    <h4><small>0</small></h4>
                </div>
            </div> */}
              <div class="col-12">
                <div class="card p-1 shadow-sm main-1-border1">
                    <h6><small>Reward Income</small></h6>
                    <h4 class="fw-bold"><small>  {deshboard?.rewardIncome
                    ? deshboard?.rewardIncome?.toFixed(2)
                    : 0}</small></h4>
                </div>
            </div>
        </div>
    </div>
    
        </div>
        <div style={{ height: "100px" }}></div>
    </div>
  )
}

export default Reserve